import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { NgForm, NgModel } from '@angular/forms'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'
import { StorageService } from 'src/app/services/storage.service'
import { FuncionarioService } from 'src/app/services/funcionario.service'
import { Funcionario } from 'src/app/classes/Funcionario'
import { EscalaTrabalho } from 'src/app/classes/EscalaTrabalho'
@Component({
  selector: 'app-forms-funcionario',
  templateUrl: './forms-funcionario.component.html',
  styleUrls: ['./forms-funcionario.component.scss']
})
export class FormsFuncionarioComponent implements OnInit {

  @ViewChild('Modal', { static: false }) modal: UiModalComponent
  @ViewChild('formulario', { static: false }) formulario!: NgForm;
  @Output() finalizarSave: EventEmitter<void> = new EventEmitter()
  @Input() escalasTrabalho: EscalaTrabalho[] = []

  isSubmit: boolean = false
  funcionario: Funcionario = new Funcionario()
  carregando: boolean = false

  constructor(
    private utils: UtilsService,
    private funcionarioService: FuncionarioService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {}

  abrirModal(funcionario: Funcionario = null): void {
    console.debug('funcionario', funcionario)
    if((funcionario == null && !this.utils.verificarPermissaoUsuario('IncluirFuncionario'))
      || funcionario != null && !this.utils.verificarPermissaoUsuario('EditarFuncionario'))
      return;
    if (funcionario != null){
      this.funcionario = {...funcionario} as Funcionario
    }
    else
      this.funcionario = new Funcionario()

    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
    this.formulario.resetForm();
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
);
  }

  save(): void {
    console.debug(this.funcionario)
    this.carregando = true
    this.funcionario.UsuarioCadastro = null;
    this.funcionario.UsuarioAlteracao = null;
    this.funcionario.EscalaTrabalho = null;
    if (!this.validarForm()) return

    if (this.funcionario.Id) {
      this.funcionarioService
        .putFuncionario(this.funcionario.Id, this.funcionario)
        .subscribe(
          (res) => {
            this.finalizarSaveRequestSuccess(
              'Funcionário alterado com sucesso!',
            )
          },
          (err) => {
            this.finalizarRequestError(err)
          },
        )
    } else {
      this.funcionarioService.postFuncionario(this.funcionario).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess(
            'Funcionário cadastrado com sucesso!',
          )
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

  validarForm(): boolean {
    if (this.formulario.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit()
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
  }
}
